@for (outlet of outlets; track outlet) {
<div fxLayout="row" class="location-filter">
  <div class="info-v">
    <label class="label">State</label>
    {{ outlet?.state }}
  </div>
  <div class="info-v">
    <label class="label">Outlet</label>
    {{ outlet?.name }}
  </div>
  <div class="info-v">
    <label class="label">Address</label>
    {{ outlet?.formattedAddress }}
  </div>
  <div class="info-v">
    <label class="label">Vendor name</label>
    {{ outlet?.vendorName }}
  </div>
  <div class="info-v">
    <label class="label">External id</label>
    {{ outlet?.externalId }}
  </div>
  <div fxFlex></div>
  <div class="actions">
    <button mat-button color="primary" matTooltip="Delete outlet filter"
      (click)="onDelete(outlet)"><mat-icon>delete</mat-icon></button>
  </div>
</div>
}